module.exports = __webpack_public_path__ + "static/media/app_store_btn.5e307ab6.png";